import React, { useContext, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";

import { MdFamilyRestroom, MdTipsAndUpdates } from 'react-icons/md';
import { IoIosDocument } from 'react-icons/io';
import { CgProfile, CgLogOut, CgMenu } from 'react-icons/cg';
import { AiOutlineQuestionCircle } from 'react-icons/ai'


import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/auth_context';
import Renderif from './renderif';
import { BsPerson, BsPersonCircle } from 'react-icons/bs';



export default function SideMenu() {
    const navigate = useNavigate();
    const { setUser, user, logout } = useContext(AuthContext)
    const [state, setState] = useState({
        show_appsubmenu: false
    })

    return (
        <>
            <div className='d-none d-md-block'>
                <div className='bv_sidemenu bg-white'>
                <div className='bv_sidemenu_item ' onClick={() => {
                            navigate('/client')
                        }}>
                            <img width={40} src='/assets/logo-sin-txt.png'></img>
                            <div></div>
                        </div>

                    <div className='bv_sidemenu_item bv_sidemenu_item--active'
                        onClick={() => {
                            if (user.roles.includes('Coach')) {
                                navigate('/admin')
                            }

                            if (user.roles.includes('User')) {
                                navigate('/client')
                            }



                        }}>
                        <AiFillHome size={26} color="black" />
                        <div className='text-black f-12'>Inicio</div>
                    </div>

                    <Renderif isTrue={user.roles.includes('User')}>

                        <div className='bv_sidemenu_item ' onClick={() => {
                            navigate('/client/citas')
                        }}>
                            <BsCalendar size={22} color="black" />
                            <div className='text-black f-12'>Citas</div>
                        </div>
                        <div className='bv_sidemenu_item ' onClick={() => {
                            navigate('/client/tips')
                        }}>
                            <MdTipsAndUpdates size={26} color="black" />
                            <div className='text-black f-12'>Tips</div>
                        </div>

                        <div className='bv_sidemenu_item ' onClick={() => {
                            navigate('/client/documentos')
                        }}>
                            <IoIosDocument size={26} color="black" />
                            <div className='text-black f-12'>Documentos</div>
                        </div>

                        <div className='bv_sidemenu_item ' onClick={() => {
                            navigate('/client/family')
                        }}>
                            <MdFamilyRestroom size={24} color="black" />
                            <div className='text-black f-12'>Mi Familia</div>
                        </div>

                        {/* <div className='bv_sidemenu_item ' onClick={() => {
                            navigate('/client/profile')
                        }}>
                            <CgProfile size={26} color="black" />
                            <div className='text-black f-12'>Perfil</div>
                        </div> */}

                    </Renderif>
                    <Renderif isTrue={user.roles.includes('Coach')}>
                        <div className='bv_sidemenu_item ' onClick={() => {
                            navigate('/admin/tips')
                        }}>
                            <MdTipsAndUpdates size={26} color="black" />
                            <div className='text-black f-12'>Tips</div>
                        </div>

                        <div className='bv_sidemenu_item ' onClick={() => {
                            navigate('/admin/documentos')
                        }}>
                            <IoIosDocument size={26} color="black" />
                            <div className='text-black f-12'>Documentos</div>
                        </div>

                    </Renderif>

                    <div className='col'></div>

                    <div className='bv_sidemenu_item'>
                        <AiOutlineQuestionCircle size={26} color="black" />
                        <div className='text-black f-12'>Faq</div>
                    </div>

                    {/* <div className='bv_sidemenu_item' onClick={() => {
                        logout();
                        navigate('/')
                    }}>
                        <CgLogOut size={26} color="black" />
                        <div className='text-black f-12 opacity-0'>empty</div>
                    </div> */}





                </div>
            </div>


            <div className='d-block d-md-none'>
                <Renderif isTrue={state?.show_appsubmenu}>
                    <div className='bv_appmenu_submenu'>

                        <div className='bv_appmenu_item' onClick={() => {

                            logout()
                            navigate('/')


                        }}>
                            <div className='bv-icon bv-icon--mid m-0'>
                                <CgLogOut size={22} color="black" />
                            </div>

                            <div className='text-black f-12'>Salir</div>
                        </div>

                        <div className='bv_appmenu_item' onClick={() => {
                            navigate('/client/family')
                        }}>

                            <div className='bv-icon bv-icon--mid m-0'>
                                <MdFamilyRestroom size={24} color="black" />
                            </div>
                            <div className='text-black f-12'>Falimia</div>
                        </div>
                        <div className='bv_appmenu_item' onClick={() => {
                            navigate('/client/profile')
                        }}>

                            <div className='bv-icon bv-icon--mid m-0'>
                                <CgProfile size={24} color="black" />
                            </div>
                            <div className='text-black f-12'>Perfil</div>
                        </div>

                    </div>
                </Renderif>
                <div className='bv_appmenu'>

                    <div className='bv_appmenu_item' onClick={() => {
                        if (user.roles.includes('Coach')) {
                            navigate('/admin')
                        }

                        if (user.roles.includes('User')) {
                            navigate('/client')
                        }
                    }}>
                        <div className='bv-icon bv-icon--mid m-0'>
                            <AiFillHome size={22} color="black" />
                        </div>

                        <div className='text-black f-12'>Home</div>
                    </div>


                    <div className='bv_appmenu_item' onClick={() => {
                        navigate('/client/tips')
                    }}>

                        <div className='bv-icon bv-icon--mid m-0'>
                            <MdTipsAndUpdates size={24} color="black" />
                        </div>
                        <div className='text-black f-12'>Tips</div>
                    </div>


                    <div className='bv_appmenu_item' onClick={() => {
                        navigate('/client/documentos')
                    }}>

                        <div className='bv-icon bv-icon--mid m-0'>
                            <IoIosDocument size={24} color="black" />
                        </div>
                        <div className='text-black f-12'>Documentos</div>
                    </div>

                    <div className='bv_appmenu_item' onClick={() => {
                        navigate('/client/citas')
                    }}>

                        <div className='bv-icon bv-icon--mid m-0'>
                            <BsCalendar size={20} color="black" />
                        </div>
                        <div className='text-black f-12'>Citas</div>
                    </div>

                    <div className='bv_appmenu_item' onClick={() => {
                        // setState({ ...state, show_appsubmenu: !state.show_appsubmenu })
                        navigate('/client/family')
                    }}>

                        <div className='bv-icon bv-icon--mid m-0'>
                            <MdFamilyRestroom size={24} color="black" />
                        </div>
                        <div className='text-black f-12'>Familia</div>
                    </div>




                </div>
            </div>

        </>

    )
}
export function AdminSideMenu() {
    const navigate = useNavigate();
    const { setUser, user, logout } = useContext(AuthContext)
    const [state, setState] = useState({
        show_appsubmenu: false
    })
    return (
        <>
            <div className='d-none d-md-block d-none'>
                <div className='bv_sidemenu'>

                    <div className='bv_sidemenu_item bv_sidemenu_item--active'
                        onClick={() => {
                            navigate('/administrador')
                        }}>
                        <AiFillHome size={26} color="black" />
                        <div className='text-black f-12'>Home</div>
                    </div>


                    <div className='bv_sidemenu_item bv_sidemenu_item--active ' onClick={() => {


                        navigate('/administrador/citas')


                    }}>
                        <BsCalendar size={22} color="black" />
                        <div className='text-black f-12'>Citas</div>
                    </div>


                    <div className='bv_sidemenu_item bv_sidemenu_item--active'
                        onClick={() => {

                            navigate('/administrador/especialistas')


                        }}>
                        <BsPersonCircle size={26} color="black" />
                        <div className='text-black f-12'>Usuarios</div>
                    </div>

                    <div className='bv_sidemenu_item bv_sidemenu_item--active' onClick={() => {


                        navigate('/administrador/tips')


                    }}>
                        <MdTipsAndUpdates size={26} color="black" />
                        <div className='text-black f-12'>Tips</div>
                    </div>

                    <div className='bv_appmenu_item bv_sidemenu_item--active' onClick={() => {
                        navigate('/administrador/documentos')
                    }}>

                        <div className='bv-icon bv-icon--mid m-0'>
                            <IoIosDocument size={24} color="black" />
                        </div>
                        <div className='text-black f-12'>Documentos</div>
                    </div>
                    <div className='col'></div>

                    <div className='bv_sidemenu_item'>
                        <AiOutlineQuestionCircle size={26} color="black" />
                        <div className='text-black f-12'>Faq</div>
                    </div>

                    <div className='bv_sidemenu_item' onClick={() => {
                        logout();
                        navigate('/')
                    }}>
                        <CgLogOut size={26} color="black" />
                        <div className='text-black f-12 opacity-0'>empty</div>
                    </div>
                </div>
            </div>


            <div className='d-block d-md-none'>
                {/* <Renderif isTrue={state?.show_appsubmenu}>
            <div className='bv_appmenu_submenu'>

                <div className='bv_appmenu_item'onClick={()=>{

                    logout()
                    navigate('/')

                    
                }}>
                    <div className='bv-icon bv-icon--mid m-0'>
                        <CgLogOut size={22}  color="white" />
                    </div>
                
                    <div className='text-white f-12'>Salir</div>
                </div>

                <div className='bv_appmenu_item'onClick={()=>{
                          navigate('/client/family')
                }}>
                
                    <div className='bv-icon bv-icon--mid m-0'>
                        <MdFamilyRestroom size={24} color="white" />  
                    </div>
                    <div className='text-white f-12'>Falimia</div>
                </div>
                <div className='bv_appmenu_item'onClick={()=>{
                          navigate('/client/profile')
                }}>
                
                    <div className='bv-icon bv-icon--mid m-0'>
                        <CgProfile size={24} color="white" />  
                    </div>
                    <div className='text-white f-12'>Perfil</div>
                </div>

            </div>
            </Renderif> */}
                <div className='bv_appmenu'>

                    <div className='bv_appmenu_item' onClick={() => {

                        navigate('/administrador')
                    }}>
                        <div className='bv-icon bv-icon--mid m-0'>
                            <AiFillHome size={22} color="black" />
                        </div>

                        <div className='text-black f-12'>Home</div>
                    </div>

                </div>
            </div>

        </>

    )
}

export function PsicoSideMenu() {
    const navigate = useNavigate();
    const { setUser, user, logout } = useContext(AuthContext)
    const [state, setState] = useState({
        show_appsubmenu: false
    })
    return (
        <>
            <div className='d-none d-md-block d-none'>
                <div className='bv_sidemenu'>

                    <div className='bv_sidemenu_item bv_sidemenu_item--active'
                        onClick={() => {
                            navigate('/admin')
                        }}>
                        <AiFillHome size={26} color="black" />
                        <div className='text-black f-12'>Home</div>
                    </div>

                    <div className='bv_sidemenu_item bv_sidemenu_item--active' onClick={() => {


                        navigate('/admin/tips')


                    }}>
                        <MdTipsAndUpdates size={26} color="black" />
                        <div className='text-black f-12'>Tips</div>
                    </div>

                    <div className='bv_appmenu_item bv_sidemenu_item--active' onClick={() => {
                        navigate('/admin/documentos')
                    }}>

                        <div className='bv-icon bv-icon--mid m-0'>
                            <IoIosDocument size={24} color="black" />
                        </div>
                        <div className='text-black f-12'>Documentos</div>
                    </div>
                    <div className='col'></div>

                    <div className='bv_sidemenu_item'>
                        <AiOutlineQuestionCircle size={26} color="black" />
                        <div className='text-black f-12'>Faq</div>
                    </div>

                    <div className='bv_sidemenu_item' onClick={() => {
                        logout();
                        navigate('/')
                    }}>
                        <CgLogOut size={26} color="black" />
                        <div className='text-black f-12 opacity-0'>empty</div>
                    </div>
                </div>
            </div>


            <div className='d-block d-md-none'>
                <div className='bv_appmenu'>

                    <div className='bv_appmenu_item' onClick={() => {

                        navigate('/administrador')
                    }}>
                        <div className='bv-icon bv-icon--mid m-0'>
                            <AiFillHome size={22} color="black" />
                        </div>

                        <div className='text-black f-12'>Home</div>
                    </div>

                </div>
            </div>

        </>

    )
}
